module.exports = __webpack_public_path__ + "static/media/chairman.9653185a.jpeg";